module.exports = __webpack_public_path__ + "static/media/assigment.9e43b58d.png";